export default class ReservationLoginPayload {
  public type: string;
  public contractId: string;
  public email: string;

  constructor(type: "contract_id" | "email", contractId: string, email: string) {
    this.type = type as string;
    this.contractId = contractId as string;
    this.email = email as string;
  }

  toJson(){
    return {
      type: this.type,
      contract_id: this.contractId,
      email: this.email
    }
  }
}
